module.exports = __webpack_public_path__ + "img/0-lg.792c1fe1.jpg";